import React, {FunctionComponent} from 'react'
import {FormBlock, Icon, Switch, TooltipWrapper} from '../../../../shared'
import {InformationAlert} from '../../InformationAlert'
import {useGetTrustedSources, usePutTrustedSourceConfiguration} from "../../../../../hooks/queries/admin/trustedSource";
import {SkeletonSourceItem} from "../SkeletonSourceItem";
import styles from './TrustedSourcePreferenceBlock.module.scss';
import {getV3ColorCssVariable} from "../../../../../design-system/colors_v3";

const TOOLTIP_TEXT = "Pièce justificative à haut degré de confiance pour la vérification de l'identité de vos patients conforme aux exigences du rérérentiel Ségur.";
export const TrustedSourcePreferenceBlock: FunctionComponent = () => {

    const {
        query: {isLoading, data},
    } = useGetTrustedSources()

    const {defaultSources} = (!isLoading && data) || {};
    const {mutate: updateTrustedSourceConfiguration} = usePutTrustedSourceConfiguration();

    const handleUpdateSource = (configurationId: number, isEnabled: boolean) => {
        updateTrustedSourceConfiguration({configurationId, isEnabled});
    }
    return (
        <FormBlock label="Pièces justificatives de confiance" icon="emptyStar">
            <InformationAlert>
                Sélectionnez les pièces justificatives que vous considérez comme des preuves à haut degré de
                confiance pour la vérification de l'identité de vos patients. Vous devez choisir au moins
                une pièce.
            </InformationAlert>
            {!isLoading && defaultSources?.length && defaultSources.map(
                ({id, value, isSegur, configuration}, index) =>
                    value && (
                        <div className={styles.switchCustomSourceContainer}>
                            <Switch
                                name={value}
                                key={id}
                                borderBottom
                                checked={configuration.isEnabled}
                                onChange={(checked) => {
                                    handleUpdateSource(configuration.id, checked)
                                }}
                                testId={`switch-custom_source_accepted-${index}`}
                            />
                          {isSegur &&
                            <TooltipWrapper content={TOOLTIP_TEXT}>
                                <Icon icon="infoCircle" color={getV3ColorCssVariable('shades', 'shade4')} size="micro"/>
                            </TooltipWrapper>
                          }
                        </div>
                    ),
            )}
            {isLoading && [0, 1, 2].map(value => {
                return (
                    <SkeletonSourceItem key={value}/>)
            })}
        </FormBlock>
    )
}
